





























































import DatePicker from '@/components/ui/DatePicker.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
	components: {
		DatePicker,
	},
})
export default class DialogoDeFiltrosDeClientes extends Vue {
	mostra = false
	filtros = {
		cep: '',
		rua: '',
		estado: '',
		telefone: '',
		email: '',
		nascimento: '',
	}
	menuNascimento = false
	erroTelefone = ''
	erroEmail = ''
	erroCep = ''

	estadosBrasileiros = [
		{ sigla: 'AC', nome: 'Acre' },
		{ sigla: 'AL', nome: 'Alagoas' },
		{ sigla: 'AP', nome: 'Amapá' },
		{ sigla: 'AM', nome: 'Amazonas' },
		{ sigla: 'BA', nome: 'Bahia' },
		{ sigla: 'CE', nome: 'Ceará' },
		{ sigla: 'DF', nome: 'Distrito Federal' },
		{ sigla: 'ES', nome: 'Espírito Santo' },
		{ sigla: 'GO', nome: 'Goiás' },
		{ sigla: 'MA', nome: 'Maranhão' },
		{ sigla: 'MT', nome: 'Mato Grosso' },
		{ sigla: 'MS', nome: 'Mato Grosso do Sul' },
		{ sigla: 'MG', nome: 'Minas Gerais' },
		{ sigla: 'PA', nome: 'Pará' },
		{ sigla: 'PB', nome: 'Paraíba' },
		{ sigla: 'PR', nome: 'Paraná' },
		{ sigla: 'PE', nome: 'Pernambuco' },
		{ sigla: 'PI', nome: 'Piauí' },
		{ sigla: 'RJ', nome: 'Rio de Janeiro' },
		{ sigla: 'RN', nome: 'Rio Grande do Norte' },
		{ sigla: 'RS', nome: 'Rio Grande do Sul' },
		{ sigla: 'RO', nome: 'Rondônia' },
		{ sigla: 'RR', nome: 'Roraima' },
		{ sigla: 'SC', nome: 'Santa Catarina' },
		{ sigla: 'SP', nome: 'São Paulo' },
		{ sigla: 'SE', nome: 'Sergipe' },
		{ sigla: 'TO', nome: 'Tocantins' },
	]

	mostrar(filtrosAtivos?: any) {
		if (filtrosAtivos) {
			this.filtros = { ...filtrosAtivos };
		}
		this.mostra = true;
	}

	formatarCep() {
		const cep = this.filtros.cep.replace(/\D/g, '');
		
		if (cep.length <= 5) {
			this.filtros.cep = cep;
		} else {
			this.filtros.cep = cep.substring(0, 5) + '-' + cep.substring(5, 8);
		}

		if (cep.length > 8) {
			this.erroCep = 'CEP excede o numero de dígitos';
		} else {
			this.erroCep = '';
		}
	}

	formatarTelefone() {
		const telefone = this.filtros.telefone.replace(/\D/g, '');
		
		if (telefone.length === 0) {
			this.filtros.telefone = '';
			this.erroTelefone = '';
			return;
		}

		if (telefone.length <= 2) {
			this.filtros.telefone = `(${telefone}`;
		} else if (telefone.length <= 6) {
			this.filtros.telefone = `(${telefone.substring(0, 2)}) ${telefone.substring(2)}`;
		} else if (telefone.length <= 10) {
			this.filtros.telefone = `(${telefone.substring(0, 2)}) ${telefone.substring(2, 6)}-${telefone.substring(6)}`;
		} else {
			this.filtros.telefone = `(${telefone.substring(0, 2)}) ${telefone.substring(2, 7)}-${telefone.substring(7, 11)}`;
		}

		if (telefone.length < 10 || telefone.length > 11) {
			this.erroTelefone = 'Telefone deve ter 10 ou 11 dígitos';
		} else {
			this.erroTelefone = '';
		}
	}

	validarEmail() {
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		
		if (this.filtros.email && !emailRegex.test(this.filtros.email)) {
			this.erroEmail = 'Email inválido';
		} else if(this.filtros.email === null) {
			this.filtros.email = '';
		} 
		else {
			this.erroEmail = '';
		}
	}

	aplicarFiltros() {
		if (this.erroTelefone || this.erroEmail) {
			return;
		}

		this.$emit('aplicar-filtros', { ...this.filtros })
		this.mostra = false
	}

	limparFiltros() {
		this.filtros = {
			cep: '',
			rua: '',
			estado: '',
			telefone: '',
			email: '',
			nascimento: '',
		}
		this.erroTelefone = ''
		this.erroEmail = ''
		this.$emit('limpar-filtros')
	}

	limparErroTelefone() {
		this.erroTelefone = '';
	}

	limparErroEmail() {
		this.erroEmail = '';
	}
}
